import { render, staticRenderFns } from "./infoCollect.vue?vue&type=template&id=0022bbc3&scoped=true"
import script from "./infoCollect.vue?vue&type=script&lang=js"
export * from "./infoCollect.vue?vue&type=script&lang=js"
import style0 from "./infoCollect.vue?vue&type=style&index=0&id=0022bbc3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022bbc3",
  null
  
)

export default component.exports